import RestService from './RestService'

export default class ModelService extends RestService {
    constructor() {
        super('models')
    }

    saveAttachment(modelId, fieldId, recordId, file) {
        let url = this.baseUrl + '/api/v1/attachments/create/' + modelId

        let formData = new FormData()
        formData.append('attachment[name]', file.name)
        formData.append('attachment[file]', file)
        formData.append('attachment[field_id]', fieldId)
        formData.append('attachment[record_id]', recordId)


        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(formData)
                .set('x-api-token', this.authToken)
                .set('Accept', 'application/json')
                .end((error, response) => {

                    if (response.status === 200 || response.status === 201) {
                        let updatedRecord = JSON.parse(response.text)
                        console.log('Attachment saved')
                        console.log(updatedRecord)
                        resolve(updatedRecord)
                    } else {
                        this.messageUtil.error(response.statusText)
                        reject(response.statusText)
                    }

                })
        })
    }

    removeAttachment(modelId, attachment) {
        let url = this.baseUrl + '/api/v1/attachments/remove/' + modelId
        return new Promise((resolve, reject) => {
            this.http.post(url)
                .send(attachment)
                .set('x-api-token', this.authToken)
                .set('Accept', 'aaplication/json')
                .end((error, response) => {
                    if (response.status === 200 || response.status === 202) {
                        let updatedRecord = JSON.parse(response.text)
                        console.log('Attachment Removed')
                        console.log(updatedRecord)
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }

    // saveDocument(modelId, document) {
    //     let request = {
    //         record: document
    //     }
    //
    //     if(document['id']) {
    //         return this.updateRow(modelId, request)
    //     }
    //     else {
    //         return this.createRow(modelId, request)
    //     }
    // }
    //
    // createRow(modelId, row) {
    //     return new Promise((resolve, reject) => {
    //         this.http.post('/api/v1/' + this.modelPath + '/create-record/' + modelId)
    //             .send(row)
    //             .set('x-api-token', this.authToken)
    //             .set('Accept', 'application/json')
    //             .end((error, response) => {
    //                 if (response.status === 200 || response.status === 201) {
    //                     let oldDocument = row.record
    //                     let newDocument = JSON.parse(response.text)
    //                     oldDocument.id = newDocument.id
    //                     resolve(newDocument)
    //                 } else {
    //                     reject(response.statusText)
    //                 }
    //             })
    //     })
    // }
    //
    // updateRow(modelId, row) {
    //     return new Promise((resolve, reject) => {
    //         this.http.put('/api/v1/' + this.modelPath + '/update-record/' + modelId)
    //             .send(row)
    //             .set('x-api-token', this.authToken)
    //             .set('Accept', 'application/json')
    //             .end((error, response) => {
    //                 if (response.status === 200 || response.status === 201) {
    //                     resolve(JSON.parse(response.text))
    //                 } else {
    //                     reject(response.statusText)
    //                 }
    //             })
    //     })
    // }
    //
    //
    // getData(table) {
    //     return new Promise((resolve, reject) => {
    //         this.http.get('/api/v1/' + this.modelPath + '/get-data/' + table.id)
    //             .set('x-api-token', this.authToken)
    //             .end((error, response) => {
    //                 if (response.status === 200) {
    //                     const records = JSON.parse(response.text);
    //                     for (let i = 0; i < records.length; i++) {
    //                         records[i].editMode = false
    //
    //                         if(records[i].records !== undefined) {
    //                             continue
    //                         }
    //
    //                         // ensure every field in a record is reactive
    //                         // for very large tables this will have a performance penalty
    //                         // one work around it to save the record with a field value
    //                         // when the field is created.
    //                         for (let j = 0; j < table.fields.length; j++) {
    //                             let field = table.fields[j]
    //
    //                             if (records[i][field.index] === undefined) {
    //                                 records[i][field.index] = ''
    //                             }
    //                         }
    //                     }
    //                     resolve(records);
    //                 } else {
    //                     reject(response.statusText)
    //                 }
    //             })
    //     })
    // }
    //
    // getChildData(table, parentId) {
    //     return new Promise((resolve, reject) => {
    //         this.http.get('/api/v1/' + this.modelPath + '/get-children-data/' + table.id + '/' + parentId)
    //             .set('x-api-token', this.authToken)
    //             .end((error, response) => {
    //                 if (response.status === 200) {
    //                     const records = JSON.parse(response.text);
    //                     for (let i = 0; i < records.length; i++) {
    //                         records[i].editMode = false
    //
    //                         // ensure every field in a record is reactive
    //                         // for very large tables this will have a performance penalty
    //                         // one work around it to save the record with a field value
    //                         // when the field is created.
    //                         for (let j = 0; j < table.fields.length; j++) {
    //                             let field = table.fields[j]
    //
    //                             if (records[i][field.name] === undefined) {
    //                                 records[i][field.name] = ''
    //                             }
    //                         }
    //                     }
    //                     resolve(records);
    //                 } else {
    //                     reject(response.statusText)
    //                 }
    //             })
    //     })
    // }

    getDocument(table, documentId) {
        let url = this.baseUrl + '/api/v1/' + this.modelPath + '/' + table.id + '/document/' + documentId
        return new Promise((resolve, reject) => {
            this.http.get(url)
                .set('x-api-token', this.authToken)
                .end((error, response) => {
                    if (response.status === 200) {
                        const record = JSON.parse(response.text);
                        record.editMode = false

                        // ensure every field in a record is reactive
                        // for very large tables this will have a performance penalty
                        // one work around it to save the record with a field value
                        // when the field is created.
                        // for (let j = 0; j < table.fields.length; j++) {
                        //     let field = table.fields[j]
                        //
                        //     if (record[field.name] === undefined) {
                        //         record[field.name] = ''
                        //     }
                        // }

                        resolve(record);
                    } else {
                        reject(response.statusText)
                    }
                })
        })
    }
}